import { deleteResourceFilter } from '@dispatch/shared/services';
import { useMutation } from 'react-query';

export const useDeleteResourceFilter = (
  userId: string,
  onSuccess: () => void
) => {
  const { mutate, error, status } = useMutation(
    ['delete-resource-filter', userId],
    async (filterId: string) => deleteResourceFilter(userId, filterId),
    {
      onSuccess,
    }
  );

  return {
    deleteResourceFilter: mutate,
    error,
    status,
  };
};
